import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, QueryList, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { EModalName, ShowModal } from '../../store/actions/modal.action';
import { NgForOf, NgIf } from '@angular/common';
import { UxaMastheadModule } from '@ux-aspects-universal/angular/masthead';
import { UxaLogoModule } from '@ux-aspects-universal/angular/logo';
import { UxaToggleSwitchModule } from '@ux-aspects-universal/angular/toggle-switch';
import { ReadMoreLessService } from '../../services/read-more-less.service';

interface NavItem {
  title: string;
  routerLink: string;
  selected: boolean;
}

@Component({
  selector: 'app-mitre-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterModule,
    NgIf,
    NgForOf,
    UxaMastheadModule,
    UxaLogoModule,
    UxaToggleSwitchModule
  ],
  standalone: true
})
export class HeaderComponent implements OnInit {
  items: NavItem[] = [];

  isSentinel = false;

  currentRoute: string;

  isSwitchVisible = false;

  isEnabled = false;

  @ViewChild('mastheadTab') mastheadTab!: QueryList<ElementRef>;

  constructor(
    private readonly _store: Store<{object}>,
    private readonly _router: Router,
    private readMoreLessService: ReadMoreLessService
  ) {}

  ngOnInit(): void {
    // subscribe to router navigation end event to get current route
    this._router.events
      .pipe(filter((event: NavigationEnd) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRoute = event.url;
        this.isEnabled = this.currentRoute.indexOf('sentinel') > -1;
        this.isSwitchVisible = (this.currentRoute.indexOf('real-time') > -1 || this.currentRoute.indexOf('sentinel') > -1);

        this.items = [
          {
            title: 'Layered Analytics (All)',
            routerLink: '/layered-analytics',
            selected: false
          },
          {
            title: 'Real-Time',
            routerLink: '/real-time',
            selected: false
          },
          {
            title: 'Machine Learning',
            routerLink: '/machine-learning',
            selected: false
          },
          {
            title: 'Search and Hunt',
            routerLink: '/search-and-hunt',
            selected: false
          },
        ];

        // To ensure that the Real-Time tab is selected for the '/sentinel' URL
        if (this.isEnabled) {
          this.items.find(item => item.title === 'Real-Time').selected = true;
        }

        // To resize the solution container whenever a change in URL is detected
        this.readMoreLessService.resizeContainer();
      });
  }

  showLandingModal(event: MouseEvent): void {
    event.preventDefault();

    this._store.dispatch(
      new ShowModal({
        name: EModalName.Landing,
      })
    );
  }

  toggleWindow() {
    if (this.isEnabled) {
      this._router.navigate(['/sentinel']);
    } else {
      this._router.navigate(['/real-time']);
    }
  }
}
